// This file is auto-generated by @hey-api/openapi-ts

export type UpdateNutzerDto = {
    /**
     * IdP ID of the user
     */
    idpId: string;
    /**
     * Anrede of the user
     */
    anrede: string;
    /**
     * Titel of the user
     */
    titel?: string;
    /**
     * Vorname of the user
     */
    vorname: string;
    /**
     * Nachname of the user
     */
    nachname: string;
    /**
     * E-Mail of the user
     */
    email: string;
    /**
     * Telefon of the user
     */
    telefon?: string;
};

export type NutzerDto = {
    /**
     * IdP ID of the user
     */
    idpId: string;
    /**
     * Anrede of the user
     */
    anrede: string;
    /**
     * Titel of the user
     */
    titel?: string;
    /**
     * Vorname of the user
     */
    vorname: string;
    /**
     * Nachname of the user
     */
    nachname: string;
    /**
     * E-Mail of the user
     */
    email: string;
    /**
     * Telefon of the user
     */
    telefon?: string;
    rollen: ['FFA_ADMIN' | 'FFA_USER' | 'COMPANY_USER'];
    /**
     * Whether the e-mail was verified
     */
    emailVerifiziert?: boolean;
};

export type UpdateUnternehmenszuordnungDto = {
    /**
     * IdP ID of the user
     */
    nutzerIdpId: string;
    /**
     * Rolle of the user for the unternehmen
     */
    rolle: 'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN';
    /**
     * Whether the unternehmenszuordnung is currently active
     */
    aktiv: boolean;
};

export type UnternehmenszuordnungDto = {
    /**
     * IdP ID of the user
     */
    nutzerIdpId: string;
    /**
     * ID of the unternehmen
     */
    unternehmenId: number;
    /**
     * Name of the unternehmen
     */
    unternehmenName: string;
    /**
     * Whether the unternehmen is currently active
     */
    unternehmenAktiv: boolean;
    /**
     * Rolle of the user for the unternehmen
     */
    rolle: 'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN';
    /**
     * Whether the unternehmenszuordnung is currently active
     */
    aktiv: boolean;
    /**
     * Whether the unternehmenszuordnung is a ffa_unternehmen
     */
    ffaUnternehmen: boolean;
};

export type CreateUnternehmenszuordnungDto = {
    /**
     * E-Mail of the user
     */
    email: string;
    /**
     * Rolle of the user for the unternehmen
     */
    rolle: 'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN';
    /**
     * Whether the unternehmenszuordnung is currently active
     */
    aktiv: boolean;
};

export type CreateNutzerDto = {
    /**
     * Anrede of the user
     */
    anrede: string;
    /**
     * Titel of the user
     */
    titel?: string;
    /**
     * Vorname of the user
     */
    vorname: string;
    /**
     * Nachname of the user
     */
    nachname: string;
    /**
     * E-Mail of the user
     */
    email: string;
    /**
     * Telefon of the user
     */
    telefon?: string;
};

export type CreateNebenantragDto = {
    /**
     * ID of the desired Nebenantragsart
     */
    nebenantragsartId?: number;
    /**
     * ID of the referenced Foerderantrag
     */
    hauptantragId?: number;
};

export type AntragsnummerDto = {
    /**
     * Antragsnummer of the Antrag
     */
    antragsnummer: string;
    /**
     * Id of the Antrag
     */
    id: number;
};

export type CreateBearbeiterDto = {
    /**
     * IdP ID of the user
     */
    nutzerIdpId: string;
    /**
     * List of Foerderantrag IDs
     */
    foerderantragIds: Array<number>;
};

export type BearbeiterDto = {
    /**
     * IdP ID of the user
     */
    nutzerIdpId: string;
    /**
     * Id of the Foerderantrag
     */
    foerderantragId: number;
};

export type ModifyBearbeiterWithMultipleNutzerDto = {
    /**
     * IdP Id of the user
     */
    foerderantragId: number;
    nutzerIdpIds: Array<string>;
};

export type MaintenanceInputDto = {
    /**
     * Start time of the maintenance
     */
    start?: string;
    /**
     * End time of the maintenance
     */
    end?: string;
};

export type BroadcastNachrichtDto = {
    /**
     * Message type
     */
    messageEnum:
        | 'NUTZER_BEARBEITER_HINZUGEFUEGT'
        | 'NUTZER_BEARBEITER_ENTFERNT'
        | 'NUTZER_BEANTRAGUNGSERLAUBNIS_HINZUGEFUEGT'
        | 'NUTZER_BEANTRAGUNGSERLAUBNIS_ENTFERNT'
        | 'NUTZER_HINZUGEFUEGT'
        | 'NUTZER_ENTFERNT'
        | 'NUTZER_ADMIN'
        | 'NUTZER_ANTRAGSTELLER'
        | 'NUTZER_AKTIV'
        | 'NUTZER_INAKTIV'
        | 'DOKUMENTZUSTELLUNG'
        | 'UNTERNEHMENSREGISTRIERUNG'
        | 'ERSTREGISTRIERUNG'
        | 'ANTRAG_EINGEREICHT'
        | 'ANTRAG_UNTERNEHMENSREGISTRIERUNG_EINGEREICHT'
        | 'ANTRAG_STAMMDATENAENDERUNG_EINGEREICHT'
        | 'NEBENANTRAG_EINGEREICHT'
        | 'ANTRAG_WIDERSPRUCH_EINGEREICHT'
        | 'ANTRAG_ZURUECKGEZOGEN_EINGEREICHT'
        | 'STATUS_AENDERUNG'
        | 'STATUS_DATENNACHFORDERUNG'
        | 'STATUS_KOMMISSION_DATENNACHREICHUNG'
        | 'STATUS_STAMMDATENAENDERUNG_BEWILLIGT'
        | 'STATUS_STAMMDATENAENDERUNG_ABGELEHNT'
        | 'STATUS_STAMMDATENREGISTRIERUNG_ABGELEHNT'
        | 'NEUE_DATENSCHUTZBEDINGUNGEN'
        | 'NEUE_NUTZUNGSBEDINGUNGEN'
        | 'DOWNTIMES_ANKUENDIGUNG'
        | 'ALLGEMEINE_BENACHRICHTIGUNG';
    /**
     * Parameters for message content
     */
    templateModel?: Record<string, Record<string, unknown>>;
};

export type UpdateUnternehmensnameDto = {
    /**
     * The name of the Unternehmen
     */
    unternehmensname: string;
};

export type ConfirmAbholungDto = {
    /**
     * The identifier of the Antrag in CMIS
     */
    antragIdentifier: string;
    /**
     * The version identifier of the form JSON object in CMIS
     */
    jsonVersionIdentifier: string;
    /**
     * The version identifier of the form PDF resource in CMIS
     */
    pdfVersionIdentifier: string;
    /**
     * The version identifier of the form XML resource in CMIS
     */
    xmlVersionIdentifier: string;
};

export type NutzerAdminResponseDto = {
    /**
     * IdP ID of the user
     */
    idpId: string;
    /**
     * Anrede of the user
     */
    anrede: string;
    /**
     * Titel of the user
     */
    titel?: string;
    /**
     * Vorname of the user
     */
    vorname: string;
    /**
     * Nachname of the user
     */
    nachname: string;
    /**
     * E-Mail of the user
     */
    email: string;
    /**
     * Telefon of the user
     */
    telefon?: string;
    /**
     * Whether the e-mail was verified
     */
    emailVerifiziert: boolean;
    /**
     * Rolle of the user
     */
    rolle: 'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN';
    /**
     * Whether the unternehmenszuordnung is currently active
     */
    aktiv: boolean;
};

export type PaginatedResponseNutzerAdminResponseDto = {
    content?: Array<NutzerAdminResponseDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

/**
 * Adresse of the Unternehmen
 */
export type AdresseDto = {
    /**
     * ID of the Adresse
     */
    id: number;
    /**
     * Bezeichnung of Land of the Adresse
     */
    land: string;
    /**
     * Bezeichnung of Bundesland of the Adresse
     */
    bundesland?: string;
    /**
     * PLZ of the Adresse
     */
    plz?: string;
    /**
     * Ort of the Adresse
     */
    ort?: string;
    /**
     * Strasse of the Adresse
     */
    strasse?: string;
    /**
     * Hausnummer of the Adresse
     */
    hausnummer?: string;
    /**
     * Zusatz of the Adresse
     */
    zusatz?: string;
    /**
     * Freitext of the Adresse used for international adress
     */
    anschriftFreitext?: string;
};

/**
 * Geschaeftsfuehrer of the Unternehmen
 */
export type GeschaeftsfuehrerDto = {
    /**
     * ID of the Geschaeftsfuehrer
     */
    id: number;
    /**
     * Anrede of the Geschaeftsfuehrer
     */
    anrede: string;
    /**
     * Titel of the Geschaeftsfuehrer
     */
    titel?: string;
    /**
     * Vorname of the Geschaeftsfuehrer
     */
    vorname: string;
    /**
     * Nachname of the Geschaeftsfuehrer
     */
    nachname: string;
};

/**
 * Niederlassung of the Unternehmen
 */
export type NiederlassungDto = {
    /**
     * ID of the Niederlassung
     */
    id: number;
    /**
     * Name of the Niederlassung
     */
    name: string;
    adresse?: AdresseDto;
};

export type UnternehmenWithRelationsDto = {
    /**
     * ID of the Unternehmen
     */
    id: number;
    /**
     * Kunden-ID of the Unternehmen (also known as Kundennummer)
     */
    ffaid: string;
    /**
     * Name of the Unternehmen
     */
    unternehmensname: string;
    /**
     * Bezeichnung of Rechtsform of the Unternehmen
     */
    rechtsform: string;
    /**
     * Rechtsform of the Unternehmen if it is not included in the selection of Rechtsform
     */
    andereRechtsform?: string;
    geschaeftsfuehrer: Array<GeschaeftsfuehrerDto>;
    niederlassungen?: Array<NiederlassungDto>;
    adresse: AdresseDto;
    /**
     * Homepage of the Unternehmen
     */
    homepage?: string;
    /**
     * Umsatzsteuer-ID of the Unternehmen
     */
    umsatzsteuerId?: string;
    /**
     * Whether the Unternehmen is considered as 'Kleine und mittlere Unternehmen'
     */
    kmu?: boolean;
    /**
     * Whether the Unternehmen is vorsteuerabzugsberechtigt
     */
    vorsteuerabzugsberechtigt?: boolean;
    /**
     * Steueridentifikationsnummer of the Unternehmen
     */
    steueridentifikationsnummer?: string;
    /**
     * Whether the Unternehmen is a juristische person
     */
    juristischePerson?: boolean;
    /**
     * Dokument Id for the HRA, or Gewerbeschein
     */
    dokumentIdForHraOrGewerbeschein?: number;
    /**
     * Dokument Name for the HRA, or Gewerbeschein
     */
    dokumentnameForHraOrGewerbeschein?: string;
    /**
     * Id of the registration foederantrag of the unternehmen
     */
    idOfRegistrationForm: number;
};

export type NebenantragsartDto = {
    /**
     * Id of the Nebenantragsart
     */
    id: number;
    /**
     * Gateway shortname of the Nebenantragsart
     */
    gatewayShortname: string;
    /**
     * Bezeichnung of the Nebenantragsart
     */
    bezeichnung: string;
    /**
     * Sortierposition of the Nebenantragsart
     */
    sortierPosition: number;
};

export type NebenantragsartCountDto = {
    /**
     * Id of the Nebenantragsart
     */
    id: number;
    /**
     * Gateway shortname of the Nebenantragsart
     */
    gatewayShortname: string;
    /**
     * Bezeichnung of the Nebenantragsart
     */
    bezeichnung: string;
    /**
     * Sortierposition of the Nebenantragsart
     */
    sortierPosition: number;
    /**
     * Number of Nebenantraege with Nebenantragsart for a given Foerderantrag
     */
    amount: number;
};

export type NebenantragDto = {
    /**
     * Id of the Nebenantrag
     */
    id: number;
    /**
     * Antragsnummer of the Nebenantrag
     */
    antragsnummer: string;
    /**
     * Status of the Nebenantrag
     */
    status:
        | 'ANTRAG_ANGELEGT'
        | 'ANTRAG_EINGEREICHT'
        | 'PRUEFUNG'
        | 'PRUEFUNG_ERNEUT'
        | 'ANTRAG_ZURUECKGEZOGEN'
        | 'ANTRAG_DATENNACHFORDERUNG'
        | 'KOMMISSION'
        | 'KOMMISSION_DATENNACHREICHUNG'
        | 'ABLEHNUNG'
        | 'ZUSAGE_PRUEFUNG'
        | 'ANTRAG_BEWILLIGT'
        | 'VERWENDUNGSNACHWEISPRUEFUNG'
        | 'WIDERSPRUCH'
        | 'TILGUNG'
        | 'ABGESCHLOSSEN'
        | 'DATENUEBERNAHME'
        | 'DATENUEBERNAHME_ABGESCHLOSSEN'
        | 'WIRD_EINGEREICHT'
        | 'ABHOLBEREIT'
        | 'ABGEHOLT'
        | 'ANTRAG_GELOESCHT';
    /**
     * Date of the last update of the Nebenantrag
     */
    aktualisiertAm: string;
    /**
     * E-Mail of Nutzer who did the last update of the Nebenantrag
     */
    aktualisiertVon: string;
    /**
     * Gateway Id of the Nebenantrag
     */
    gatewayId?: string;
    /**
     * FFMS uuid of the Nebenantrag
     */
    fmsUuid?: string;
    /**
     * formular shortname of the Nebenantrag
     */
    formularShortname?: string;
};

export type PaginatedResponseNebenantragDto = {
    content?: Array<NebenantragDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

export type HistorieDto = {
    /**
     * Id of the Historie
     */
    id: number;
    /**
     * Bezeichnung of Aenderungsart of the Historie
     */
    aenderungsart: string;
    /**
     * Zeitstempel of the Historie
     */
    zeitstempel: string;
    /**
     * Ansprechpartner of the Historie
     */
    ansprechpartner: string;
    /**
     * Kommentar of the Historie
     */
    kommentar?: string;
};

export type PaginatedResponseHistorieDto = {
    content?: Array<HistorieDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

export type FoerderbereichDto = {
    /**
     * ID of the Foerderbereich
     */
    id: number;
    /**
     * Bezeichnung of the Foerderbereich
     */
    bezeichnung: string;
    /**
     * Sort position of the Foerderbereich
     */
    sortierPosition: number;
};

export type FoerderartDto = {
    /**
     * Id of the Foerderart
     */
    id: number;
    /**
     * Bezeichnung of the Foerderart
     */
    bezeichnung: string;
    /**
     * Rechtsgrundlage of the Foerderart
     */
    rechtsgrundlage: string;
    /**
     * Bezeichnung of the Foerderbereich of the Foerderart
     */
    foerderbereichBezeichnung: string;
    /**
     * Date when the Foerderart can not be submitted anymore
     */
    gueltigBis?: string;
    /**
     * Gateway shortname of the Foerderart
     */
    gatewayShortname: string;
    /**
     * Sort position of the Foerderbereich
     */
    sortierPosition: number;
};

export type FoerderantragDto = {
    /**
     * Id of the Foerderantrag
     */
    id: number;
    /**
     * Status of the Foerderantrag
     */
    status:
        | 'ANTRAG_ANGELEGT'
        | 'ANTRAG_EINGEREICHT'
        | 'PRUEFUNG'
        | 'PRUEFUNG_ERNEUT'
        | 'ANTRAG_ZURUECKGEZOGEN'
        | 'ANTRAG_DATENNACHFORDERUNG'
        | 'KOMMISSION'
        | 'KOMMISSION_DATENNACHREICHUNG'
        | 'ABLEHNUNG'
        | 'ZUSAGE_PRUEFUNG'
        | 'ANTRAG_BEWILLIGT'
        | 'VERWENDUNGSNACHWEISPRUEFUNG'
        | 'WIDERSPRUCH'
        | 'TILGUNG'
        | 'ABGESCHLOSSEN'
        | 'DATENUEBERNAHME'
        | 'DATENUEBERNAHME_ABGESCHLOSSEN'
        | 'WIRD_EINGEREICHT'
        | 'ABHOLBEREIT'
        | 'ABGEHOLT'
        | 'ANTRAG_GELOESCHT';
    /**
     * Antragsteller of the Foerderantrag
     */
    antragsteller: string;
    /**
     * Gateway Id of the Foerderantrag
     */
    gatewayId?: string;
    /**
     * Formularshortname of the Foerderantrag
     */
    formularShortname?: string;
    /**
     * FMS uuid of the Foerderantrag
     */
    fmsUuid?: string;
    /**
     * Antragsnummer of the Foerderantrag
     */
    antragsnummer: string;
    /**
     * Foerdernummer of the Foerderantrag
     */
    foerdernummer?: string;
    /**
     * Date of the last update of the Foerderantrag
     */
    aktualisiertAm: string;
    /**
     * Date when the Foerderantrag was eingereicht
     */
    eingereichtAm?: string;
    /**
     * E-Mail of Nutzer who did the last update of the Foerderantrag
     */
    aktualisiertVon: string;
    /**
     * Bezeichnung of Foerderart of the Foerderantrag
     */
    foerderartBezeichnung: string;
    /**
     * Bool if the foerderart is still akitv
     */
    foerderartAktiv: boolean;
    /**
     * Date when the Foerderart can not be submitted anymore
     */
    foerderartGueltigBis?: string;
    /**
     * Projektname of the Foerderantrag
     */
    projektname: string;
    /**
     * Timestamp when the antrag can be edited
     */
    fristFreischaltung?: string;
    /**
     * Timestamp when the antrag has to be submitted again
     */
    fristEnde?: string;
    /**
     * Bool if there is an Widerruf Nebenantrag, that is submitted but not finished
     */
    hasPendingWiderspruch?: boolean;
    /**
     * Bool if there is an Zurueckziehen Nebenantrag, that is submitted but not finished
     */
    hasPendingRuecknahme?: boolean;
    /**
     * Bool if there is an form.pdf in the DB
     */
    hasAntragPdf?: boolean;
};

export type PaginatedResponseFoerderantragDto = {
    content?: Array<FoerderantragDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

export type DokumentContentDto = {
    /**
     * Name of the Dokument
     */
    filename: string;
    /**
     * Id of the Dokument
     */
    dokumentId: number;
    /**
     * Content of the document
     */
    content: string;
};

export type AntragsDokumentDto = {
    /**
     * Antragsnummer of the Foerderantrag
     */
    antragAntragsnummer: string;
    /**
     * Name of the Dokument
     */
    name: string;
    /**
     * Dateityp of the Dokument
     */
    dateityp: string;
    /**
     * TagType of the Dokument
     */
    tagType:
        | 'FORM_JSON'
        | 'FORM_PDF'
        | 'FORM_XML'
        | 'FORM_JSON_OLD'
        | 'FORM_PDF_OLD'
        | 'FORM_XML_OLD'
        | 'FORM_REOPEN_XML'
        | 'ATTACHMENT'
        | 'FFA_DOCUMENT'
        | 'FFA_BESCHEID'
        | 'PORTAL_RECHTLICHES'
        | 'MALWARE_INFO'
        | 'ERROR_INFO'
        | 'DELETABLE';
    /**
     * Byte content of the Dokument
     */
    content: string;
};

export type RequiredLesebestaetigungDto = {
    /**
     * Name of the Dokument
     */
    dokumentname: string;
    /**
     * Projektname of the Foerderantrag
     */
    projektname: string;
};

export type FfaDokumentDto = {
    /**
     * Id of the Dokument
     */
    id: number;
    /**
     * Name of the Dokument
     */
    name: string;
    /**
     * Antragsnummer of the Foerderantrag
     */
    antragsnummer: string;
    /**
     * TagType of the Dokument
     */
    type:
        | 'FORM_JSON'
        | 'FORM_PDF'
        | 'FORM_XML'
        | 'FORM_JSON_OLD'
        | 'FORM_PDF_OLD'
        | 'FORM_XML_OLD'
        | 'FORM_REOPEN_XML'
        | 'ATTACHMENT'
        | 'FFA_DOCUMENT'
        | 'FFA_BESCHEID'
        | 'PORTAL_RECHTLICHES'
        | 'MALWARE_INFO'
        | 'ERROR_INFO'
        | 'DELETABLE';
    /**
     * Date of receiving the Dokument
     */
    datum: string;
    /**
     * Whether the Dokument is read
     */
    gelesen?: boolean;
};

export type PaginatedResponseFfaDokumentDto = {
    content?: Array<FfaDokumentDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

export type UnternehmenSelectionDto = {
    /**
     * ID of the unternehmen
     */
    unternehmenId: number;
    /**
     * Name of the unternehmen
     */
    unternehmenName: string;
    /**
     * Whether the unternehmen is currently active
     */
    unternehmenAktiv: boolean;
};

export type FileContentDto = {
    /**
     * The content of the file as binary
     */
    content: string;
    /**
     * The name of the file
     */
    filename: string;
};

export type RenderedTemplateDto = {
    /**
     * The rendered Thymeleaf template as html
     */
    htmlContent: string;
};

export type MaintenanceDto = {
    /**
     * Start time of the maintenance
     */
    start?: string;
    /**
     * End time of the maintenance
     */
    end?: string;
};

export type PaginatedResponsePostkorbNachrichtDto = {
    content?: Array<PostkorbNachrichtDto>;
    size?: number;
    numberOfElements?: number;
    totalElements?: number;
    totalPages?: number;
    empty?: boolean;
};

export type PostkorbNachrichtDto = {
    /**
     * Id of the Postkorbnachricht
     */
    id: number;
    /**
     * Betreff of the Postkorbnachricht
     */
    betreff?: string;
    /**
     * Nachricht of the Postkorbnachricht
     */
    nachricht?: string;
    /**
     * Zustellzeitpunkt of the Postkorbnachricht
     */
    zustellzeitpunkt: string;
    /**
     * Lesebstätigung of the Postkorbnachricht
     */
    gelesen?: boolean;
    /**
     * Whether the Postkorbnachricht has attachments
     */
    mitAnhang?: boolean;
    /**
     * Whether the Postkorbnachricht has a Empfangsbestaetigung
     */
    mitEmpfangsbestaetigung?: boolean;
    /**
     * Projektname of the referenced Foerderantrag
     */
    projektname?: string;
    /**
     * Antragsnummer of the referenced Foerderantrag
     */
    antragsnummer?: string;
};

/**
 * DTO representing the content of a form
 */
export type FormContentDto = {
    /**
     * List of form fields
     */
    formContent?: Array<FormFieldDto>;
};

/**
 * DTO representing a form field
 */
export type FormFieldDto = {
    /**
     * ID of the form field
     */
    id?: string;
    /**
     * Value of the form field
     */
    value?: string;
    /**
     * Type of the form field
     */
    type?: string;
    /**
     * Readonly status of the form field
     */
    readonly?: boolean;
    /**
     * Id of the multivalue field group
     */
    hId?: string;
    /**
     * Name of the multivalue field groups
     */
    hGroupId?: string;
};

export type DokumentMappingDto = {
    /**
     * Antragsnummer of the Foerderantrag
     */
    antragAntragsnummer: string;
    /**
     * Name of the Dokument in the json file
     */
    name: string;
    /**
     * NscaleId of the Dokument
     */
    nscaleId: string;
    /**
     * FormFieldId of the Dokument
     */
    formFieldId: string;
};

export type AntragDto = {
    /**
     * Antragsnummer of the Antrag
     */
    antragsnummer: string;
    /**
     * DateTime the Antrag was submitted
     */
    eingereichtAm: string;
    /**
     * Bezeichnung of Foerderart/Nebenantragsart of the Antrag
     */
    antragsartBezeichnung: string;
    /**
     * GatewayShortname of Foerderart/Nebenantragsart of the Antrag
     */
    antragsartShortname: string;
    /**
     * Antragsnummer of the Hauptantrag of the Nebenantrag; Empty if it is a Foerderantrag
     */
    hauptantragAntragsnummer?: string;
    /**
     * Whether the Antrag is a Foerderantrag or Nebenantrag
     */
    isHauptantrag?: boolean;
    /**
     * Whether the Antrag is the first submission or a follow-up. Also set to true for any Stammdatenaktualisierung
     */
    isAenderung?: boolean;
};

export type PlatzhalterantragStatusDto = {
    /**
     * NscaleId of the Antrag
     */
    nscaleId: string;
    /**
     * Whether the Antrag was transferred
     */
    transferred?: boolean;
};

export type $OpenApiTs = {
    '/user/v1/nutzer/current': {
        get: {
            res: {
                /**
                 * Nutzer was returned
                 */
                200: NutzerDto;
            };
        };
        put: {
            req: {
                requestBody: UpdateNutzerDto;
            };
            res: {
                /**
                 * Nutzer was updated and returned
                 */
                200: NutzerDto;
            };
        };
    };
    '/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen': {
        put: {
            req: {
                requestBody: UpdateUnternehmenszuordnungDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Unternehmenszuordnung was updated and returned
                 */
                200: UnternehmenszuordnungDto;
            };
        };
        post: {
            req: {
                requestBody: CreateUnternehmenszuordnungDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Unternehmenszuordnung was created
                 */
                200: boolean;
            };
        };
    };
    '/user/unternehmen/{unternehmenId}/v1/unternehmenszuordnungen/nutzer/{nutzerIdpId}': {
        delete: {
            req: {
                nutzerIdpId: string;
                unternehmenId: number;
            };
            res: {
                /**
                 * Unternehmenszuordnung was deleted
                 */
                200: boolean;
            };
        };
    };
    '/user/ffa/v1/nutzer/{nutzerIdpId}/roles': {
        put: {
            req: {
                nutzerIdpId: string;
                requestBody: ['UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN'];
            };
            res: {
                /**
                 * Nutzer was updated and returned
                 */
                200: NutzerDto;
            };
        };
    };
    '/user/ffa/v1/nutzer/{nutzerIdpId}/password/reset': {
        put: {
            req: {
                nutzerIdpId: string;
            };
            res: {
                /**
                 * Password was reset
                 */
                200: boolean;
            };
        };
    };
    '/user/ffa/v1/nutzer': {
        get: {
            req: {
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                rollen?: Array<'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN'>;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
            };
            res: {
                /**
                 * Page of Nutzer was returned
                 */
                200: PaginatedResponseNutzerAdminResponseDto;
            };
        };
        post: {
            req: {
                requestBody: CreateNutzerDto;
            };
            res: {
                /**
                 * Nutzer was created and returned
                 */
                201: NutzerDto;
            };
        };
    };
    '/user/ffa/v1/nutzer/{idpId}': {
        delete: {
            req: {
                idpId: string;
            };
            res: {
                /**
                 * Nutzer was deleted
                 */
                200: boolean;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/antraege/{antragId}': {
        put: {
            req: {
                antragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Antragsstatus for Antrag was updated
                 */
                200: any;
            };
        };
        delete: {
            req: {
                antragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Antragsstatus for Antrag was updated
                 */
                200: any;
            };
        };
    };
    '/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}': {
        put: {
            req: {
                postkorbNachrichtId: number;
                requestBody: boolean;
                unternehmenId: number;
            };
            res: {
                /**
                 * Gelesenstatus of Postkorbnachricht was updated
                 */
                200: boolean;
            };
        };
    };
    '/inbox/unternehmen/{unternehmenId}/v1/postkorbnachrichten': {
        get: {
            req: {
                hideAllgemeineNachrichten?: boolean;
                onlyShowAllgemeineNachrichten?: boolean;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Page of Postkorbnachricht was returned
                 */
                200: PaginatedResponsePostkorbNachrichtDto;
            };
        };
    };
    '/inbox/common/v1/postkorbnachrichten/gelesen/{postkorbNachrichtId}': {
        put: {
            req: {
                postkorbNachrichtId: number;
                requestBody: boolean;
            };
            res: {
                /**
                 * Gelesenstatus of Postkorbnachricht was updated
                 */
                200: boolean;
            };
        };
    };
    '/inbox/common/v1/postkorbnachrichten': {
        get: {
            req: {
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
            };
            res: {
                /**
                 * Page of Postkorbnachricht was returned
                 */
                200: PaginatedResponsePostkorbNachrichtDto;
            };
        };
    };
    '/user/common/v1/registration/confirm': {
        post: {
            req: {
                requestBody: string;
            };
            res: {
                /**
                 * Nutzer registration was confirmed
                 */
                200: boolean;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/nebenantraege': {
        post: {
            req: {
                requestBody: CreateNebenantragDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Successfully created new Nebenantrag
                 */
                200: AntragsnummerDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/nebenantraege/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                nebenantragsartId?: number;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                status?:
                    | 'ANTRAG_ANGELEGT'
                    | 'ANTRAG_EINGEREICHT'
                    | 'PRUEFUNG'
                    | 'PRUEFUNG_ERNEUT'
                    | 'ANTRAG_ZURUECKGEZOGEN'
                    | 'ANTRAG_DATENNACHFORDERUNG'
                    | 'KOMMISSION'
                    | 'KOMMISSION_DATENNACHREICHUNG'
                    | 'ABLEHNUNG'
                    | 'ZUSAGE_PRUEFUNG'
                    | 'ANTRAG_BEWILLIGT'
                    | 'VERWENDUNGSNACHWEISPRUEFUNG'
                    | 'WIDERSPRUCH'
                    | 'TILGUNG'
                    | 'ABGESCHLOSSEN'
                    | 'DATENUEBERNAHME'
                    | 'DATENUEBERNAHME_ABGESCHLOSSEN'
                    | 'WIRD_EINGEREICHT'
                    | 'ABHOLBEREIT'
                    | 'ABGEHOLT'
                    | 'ANTRAG_GELOESCHT';
                unternehmenId: number;
            };
            res: {
                /**
                 * list of Nebenanträge was returned
                 */
                200: PaginatedResponseNebenantragDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderantraege': {
        get: {
            req: {
                foerderart?: string;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                status?:
                    | 'ANTRAG_ANGELEGT'
                    | 'ANTRAG_EINGEREICHT'
                    | 'PRUEFUNG'
                    | 'PRUEFUNG_ERNEUT'
                    | 'ANTRAG_ZURUECKGEZOGEN'
                    | 'ANTRAG_DATENNACHFORDERUNG'
                    | 'KOMMISSION'
                    | 'KOMMISSION_DATENNACHREICHUNG'
                    | 'ABLEHNUNG'
                    | 'ZUSAGE_PRUEFUNG'
                    | 'ANTRAG_BEWILLIGT'
                    | 'VERWENDUNGSNACHWEISPRUEFUNG'
                    | 'WIDERSPRUCH'
                    | 'TILGUNG'
                    | 'ABGESCHLOSSEN'
                    | 'DATENUEBERNAHME'
                    | 'DATENUEBERNAHME_ABGESCHLOSSEN'
                    | 'WIRD_EINGEREICHT'
                    | 'ABHOLBEREIT'
                    | 'ABGEHOLT'
                    | 'ANTRAG_GELOESCHT';
                unternehmenId: number;
            };
            res: {
                /**
                 * Page of Förderantrag was returned
                 */
                200: PaginatedResponseFoerderantragDto;
            };
        };
        post: {
            req: {
                requestBody: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Successfully created new Foerderantrag
                 */
                200: AntragsnummerDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderantraege/{id}': {
        get: {
            req: {
                id: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Förderantrag was returned
                 */
                200: FoerderantragDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderantraege/nutzer/{nutzerIdpId}': {
        get: {
            req: {
                nutzerIdpId: string;
                unternehmenId: number;
            };
            res: {
                /**
                 * Successfully retrieved the list of editable funding applications
                 */
                200: Array<FoerderantragDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/bearbeiter': {
        post: {
            req: {
                requestBody: CreateBearbeiterDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Bearbeiter was returned
                 */
                200: Array<BearbeiterDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/bearbeiter/withMultipleNutzerIdpIds': {
        post: {
            req: {
                requestBody: ModifyBearbeiterWithMultipleNutzerDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Bearbeiter were created
                 */
                201: boolean;
            };
        };
        delete: {
            req: {
                requestBody: ModifyBearbeiterWithMultipleNutzerDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Bearbeitungsrechte were deleted for list of Nutzer
                 */
                200: boolean;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/bearbeiter/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Bearbeiter was returned
                 */
                200: Array<NutzerDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/bearbeiter/{nutzerIdpId}': {
        delete: {
            req: {
                nutzerIdpId: string;
                requestBody: Array<number>;
                unternehmenId: number;
            };
            res: {
                /**
                 * all of the Bearbeiter were deleted
                 */
                200: boolean;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}': {
        post: {
            req: {
                nutzerIdpId: string;
                requestBody: Array<number>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Beantragungserlaubnisse were created
                 */
                201: boolean;
            };
        };
        delete: {
            req: {
                nutzerIdpId: string;
                requestBody: Array<number>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Beantragungserlaubnisse were deleted
                 */
                200: boolean;
            };
        };
    };
    '/process/ffa/{unternehmenId}/v1/beantragungserlaubnisse/nutzer/{nutzerIdpId}': {
        post: {
            req: {
                nutzerIdpId: string;
                requestBody: Array<number>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Beantragungserlaubnisse were created
                 */
                201: boolean;
            };
        };
    };
    '/process/ffa/v1/stammdaten/update': {
        post: {
            req: {
                formData: {
                    csvfiles: Array<Blob | File>;
                };
                separator: string;
            };
            res: {
                /**
                 * Stammdaten were updated
                 */
                200: any;
            };
        };
    };
    '/process/ffa/v1/maintenance': {
        post: {
            req: {
                requestBody: MaintenanceInputDto;
            };
            res: {
                /**
                 * Successfully set up maintenance time
                 */
                200: any;
            };
        };
    };
    '/process/ffa/v1/maintenance/stop': {
        delete: {
            res: {
                /**
                 * Successfully stopped maintenance
                 */
                200: any;
            };
        };
    };
    '/process/ffa/v1/broadcast': {
        post: {
            req: {
                requestBody: BroadcastNachrichtDto;
            };
            res: {
                /**
                 * Broadcast Nachricht was sent
                 */
                200: boolean;
            };
        };
    };
    '/process/ffa/v1/broadcast/nutzungsbedingungen': {
        post: {
            res: {
                /**
                 * New Nutzungsbedingungen were sent
                 */
                200: boolean;
            };
        };
    };
    '/process/ffa/v1/broadcast/datenschutzbedingungen': {
        post: {
            res: {
                /**
                 * New Datenschutzbedingungen were sent
                 */
                200: boolean;
            };
        };
    };
    '/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}': {
        post: {
            req: {
                requestBody: CreateBearbeiterDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Bearbeiter was returned
                 */
                200: Array<BearbeiterDto>;
            };
        };
    };
    '/process/ffa/v1/bearbeiter/unternehmen/{unternehmenId}/withMultipleNutzerIdpIds': {
        post: {
            req: {
                requestBody: ModifyBearbeiterWithMultipleNutzerDto;
                unternehmenId: number;
            };
            res: {
                /**
                 * Bearbeitungsrechte were created
                 */
                201: boolean;
            };
        };
    };
    '/process/ffa/v1/bearbeiter/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
            };
            res: {
                /**
                 * List of Bearbeiter was returned
                 */
                200: Array<NutzerDto>;
            };
        };
    };
    '/process/common/v1/foerderantraege': {
        post: {
            res: {
                /**
                 * Successfully created new Foerderantrag for a new Unternehmensregistrierung
                 */
                200: AntragsnummerDto;
            };
        };
    };
    '/process/common/v1/foerderantraege/{antragsnummer}/update-unternehmensname': {
        post: {
            req: {
                antragsnummer: string;
                requestBody: UpdateUnternehmensnameDto;
            };
            res: {
                /**
                 * Successfully updated the Unternehmensname after Unternehmensregistrierung
                 */
                200: boolean;
            };
        };
    };
    '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/confirm-abholung': {
        post: {
            req: {
                antragsnummer: string;
                requestBody: ConfirmAbholungDto;
            };
            res: {
                /**
                 * Abholung confirmed
                 */
                200: any;
            };
        };
    };
    '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}': {
        get: {
            req: {
                antragsnummer: string;
            };
            res: {
                /**
                 * DTOs containing the documents were returned
                 */
                200: Array<AntragsDokumentDto>;
            };
        };
    };
    '/ext/process/nscale/v1/dokumente/antrag/{antragsnummer}/attachmentmapping': {
        get: {
            req: {
                antragsnummer: string;
            };
            res: {
                /**
                 * Mapping was returned
                 */
                200: Array<DokumentMappingDto>;
            };
        };
    };
    '/ext/process/nscale/v1/dokumente/antraege': {
        get: {
            req: {
                shortname?: string;
            };
            res: {
                /**
                 * List of Antraege was returned
                 */
                200: Array<AntragDto>;
            };
        };
    };
    '/application/common/v1/logging': {
        post: {
            req: {
                level: 'ERROR' | 'WARN' | 'INFO' | 'DEBUG' | 'TRACE';
                message: string;
            };
            res: {
                /**
                 * Message was logged
                 */
                200: boolean;
            };
        };
    };
    '/user/unternehmen/{unternehmenId}/v1/nutzer': {
        get: {
            req: {
                aktiv?: boolean;
                foerderbereiche?: Array<number>;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                rollen?: Array<'UNTERNEHMEN_MITARBEITER' | 'UNTERNEHMEN_ADMIN' | 'FFA_MITARBEITER' | 'FFA_ADMIN'>;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Page of Nutzer was returned
                 */
                200: PaginatedResponseNutzerAdminResponseDto;
            };
        };
    };
    '/user/common/v1/unternehmenszuordnungen': {
        get: {
            res: {
                /**
                 * List of active Unternehmenszuordnungen was returned
                 */
                200: Array<UnternehmenszuordnungDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/unternehmen/withRelations': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * Unternehmen was returned
                 */
                200: UnternehmenWithRelationsDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/permitted/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * list of Nebenantragsart was returned
                 */
                200: Array<NebenantragsartDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/nebenantragsarten/count/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * list of name and amount of Nebenantragsart was returned
                 */
                200: Array<NebenantragsartCountDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/historien/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                unternehmenId: number;
            };
            res: {
                /**
                 * Page of Historieneinträge was returned
                 */
                200: PaginatedResponseHistorieDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderbereiche': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Förderbereiche was returned
                 */
                200: Array<FoerderbereichDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderbereiche/nutzer/{nutzerIdpId}': {
        get: {
            req: {
                nutzerIdpId: string;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Förderbereiche was returned
                 */
                200: Array<FoerderbereichDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderbereiche/active': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Förderbereiche was returned
                 */
                200: Array<FoerderbereichDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderarten/bearbeiter': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * List of active Förderarten was returned
                 */
                200: Array<FoerderartDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/foerderarten/active': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * List of active Förderarten was returned
                 */
                200: Array<FoerderartDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/{dokumentId}': {
        get: {
            req: {
                dokumentId: number;
                foerderantragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Document was returned
                 */
                200: DokumentContentDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/dokumente/{foerderantragId}/pdf': {
        get: {
            req: {
                foerderantragId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Document was returned
                 */
                200: AntragsDokumentDto;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/dokumente/{dokumentId}/lesebestaetigung': {
        get: {
            req: {
                dokumentId: number;
                unternehmenId: number;
            };
            res: {
                /**
                 * Dokument was marked as gelesen
                 */
                200: any;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/dokumente/requiredLesebestaetigungen': {
        get: {
            req: {
                unternehmenId: number;
            };
            res: {
                /**
                 * List of required Lesebestaetigungen
                 */
                200: Array<RequiredLesebestaetigungDto>;
            };
        };
    };
    '/process/unternehmen/{unternehmenId}/v1/dokumente/ffa/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                noBescheide?: boolean;
                onlyBescheide?: boolean;
                onlyUngeleseneBescheide?: boolean;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of FFA documents
                 */
                200: PaginatedResponseFfaDokumentDto;
            };
        };
    };
    '/process/ffa/v1/unternehmen': {
        get: {
            req: {
                searchparameter?: string;
            };
            res: {
                /**
                 * List of Unternehmen was returned
                 */
                200: Array<UnternehmenSelectionDto>;
            };
        };
    };
    '/process/ffa/v1/nebenantragsarten/permitted/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
            };
            res: {
                /**
                 * list of Nebenantragsart was returned
                 */
                200: Array<NebenantragsartDto>;
            };
        };
    };
    '/process/ffa/v1/nebenantragsarten/count/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
            };
            res: {
                /**
                 * list of name and amount of Nebenantragsart was returned
                 */
                200: Array<NebenantragsartCountDto>;
            };
        };
    };
    '/process/ffa/v1/nebenantraege/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                nebenantragsartId?: number;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                status?:
                    | 'ANTRAG_ANGELEGT'
                    | 'ANTRAG_EINGEREICHT'
                    | 'PRUEFUNG'
                    | 'PRUEFUNG_ERNEUT'
                    | 'ANTRAG_ZURUECKGEZOGEN'
                    | 'ANTRAG_DATENNACHFORDERUNG'
                    | 'KOMMISSION'
                    | 'KOMMISSION_DATENNACHREICHUNG'
                    | 'ABLEHNUNG'
                    | 'ZUSAGE_PRUEFUNG'
                    | 'ANTRAG_BEWILLIGT'
                    | 'VERWENDUNGSNACHWEISPRUEFUNG'
                    | 'WIDERSPRUCH'
                    | 'TILGUNG'
                    | 'ABGESCHLOSSEN'
                    | 'DATENUEBERNAHME'
                    | 'DATENUEBERNAHME_ABGESCHLOSSEN'
                    | 'WIRD_EINGEREICHT'
                    | 'ABHOLBEREIT'
                    | 'ABGEHOLT'
                    | 'ANTRAG_GELOESCHT';
            };
            res: {
                /**
                 * list of Nebenanträge was returned
                 */
                200: PaginatedResponseNebenantragDto;
            };
        };
    };
    '/process/ffa/v1/historien/foerderantrag/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
            };
            res: {
                /**
                 * Page of Historieneinträge was returned
                 */
                200: PaginatedResponseHistorieDto;
            };
        };
    };
    '/process/ffa/v1/foerderbereiche': {
        get: {
            res: {
                /**
                 * List of Förderbereiche was returned
                 */
                200: Array<FoerderbereichDto>;
            };
        };
    };
    '/process/ffa/v1/foerderbereiche/{unternehmenId}/nutzer/{nutzerIdpId}': {
        get: {
            req: {
                nutzerIdpId: string;
                unternehmenId: number;
            };
            res: {
                /**
                 * List of Förderbereiche was returned
                 */
                200: Array<FoerderbereichDto>;
            };
        };
    };
    '/process/ffa/v1/foerderantraege': {
        get: {
            req: {
                foerderart?: string;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
                status?:
                    | 'ANTRAG_ANGELEGT'
                    | 'ANTRAG_EINGEREICHT'
                    | 'PRUEFUNG'
                    | 'PRUEFUNG_ERNEUT'
                    | 'ANTRAG_ZURUECKGEZOGEN'
                    | 'ANTRAG_DATENNACHFORDERUNG'
                    | 'KOMMISSION'
                    | 'KOMMISSION_DATENNACHREICHUNG'
                    | 'ABLEHNUNG'
                    | 'ZUSAGE_PRUEFUNG'
                    | 'ANTRAG_BEWILLIGT'
                    | 'VERWENDUNGSNACHWEISPRUEFUNG'
                    | 'WIDERSPRUCH'
                    | 'TILGUNG'
                    | 'ABGESCHLOSSEN'
                    | 'DATENUEBERNAHME'
                    | 'DATENUEBERNAHME_ABGESCHLOSSEN'
                    | 'WIRD_EINGEREICHT'
                    | 'ABHOLBEREIT'
                    | 'ABGEHOLT'
                    | 'ANTRAG_GELOESCHT';
            };
            res: {
                /**
                 * Page of Förderantrag was returned
                 */
                200: PaginatedResponseFoerderantragDto;
            };
        };
    };
    '/process/ffa/v1/foerderantraege/{id}': {
        get: {
            req: {
                id: number;
            };
            res: {
                /**
                 * Förderantrag was returned
                 */
                200: FoerderantragDto;
            };
        };
    };
    '/process/ffa/v1/foerderantraege/unternehmen/{unternehmenId}/nutzer/{nutzerIdpId}': {
        get: {
            req: {
                nutzerIdpId: string;
                unternehmenId: number;
            };
            res: {
                /**
                 * Successfully retrieved the list of editable funding applications
                 */
                200: Array<FoerderantragDto>;
            };
        };
    };
    '/process/ffa/v1/dokumente/{foerderantragId}/{dokumentId}': {
        get: {
            req: {
                dokumentId: number;
                foerderantragId: number;
            };
            res: {
                /**
                 * Document was returned
                 */
                200: DokumentContentDto;
            };
        };
    };
    '/process/ffa/v1/dokumente/{foerderantragId}/pdf': {
        get: {
            req: {
                foerderantragId: number;
            };
            res: {
                /**
                 * Document was returned
                 */
                200: AntragsDokumentDto;
            };
        };
    };
    '/process/ffa/v1/dokumente/ffa/{foerderantragId}': {
        get: {
            req: {
                foerderantragId: number;
                noBescheide?: boolean;
                onlyBescheide?: boolean;
                onlyUngeleseneBescheide?: boolean;
                /**
                 * Zero-based page index (0..N)
                 */
                page?: number;
                searchparameter?: string;
                /**
                 * The size of the page to be returned
                 */
                size?: number;
                /**
                 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
                 */
                sort?: Array<string>;
            };
            res: {
                /**
                 * List of FFA documents
                 */
                200: PaginatedResponseFfaDokumentDto;
            };
        };
    };
    '/process/common/v1/rechtliches/vollmachtFormular': {
        get: {
            res: {
                /**
                 * Vollmacht Formular file was retrieved successfully
                 */
                200: FileContentDto;
            };
        };
    };
    '/process/common/v1/rechtliches/nutzungsbedingungen': {
        get: {
            res: {
                /**
                 * Nutzungsbedingungen file was retrieved successfully
                 */
                200: FileContentDto;
            };
        };
    };
    '/process/common/v1/rechtliches/nutzungsbedingungen/download': {
        get: {
            res: {
                /**
                 * Datenschutz file was retrieved successfully
                 */
                200: Blob | File;
            };
        };
    };
    '/process/common/v1/rechtliches/impressum': {
        get: {
            res: {
                /**
                 * Impressum template was retrieved successfully
                 */
                200: RenderedTemplateDto;
            };
        };
    };
    '/process/common/v1/rechtliches/faq': {
        get: {
            res: {
                /**
                 * FAQ file was retrieved successfully
                 */
                200: FileContentDto;
            };
        };
    };
    '/process/common/v1/rechtliches/datenschutz': {
        get: {
            res: {
                /**
                 * Datenschutz file was retrieved successfully
                 */
                200: FileContentDto;
            };
        };
    };
    '/process/common/v1/rechtliches/datenschutz/download': {
        get: {
            res: {
                /**
                 * Datenschutz file was retrieved successfully
                 */
                200: Blob | File;
            };
        };
    };
    '/process/common/v1/maintenance': {
        get: {
            res: {
                /**
                 * Successfully returned maintenance time
                 */
                200: MaintenanceDto;
            };
        };
    };
    '/form/unternehmen/{unternehmenId}/v1/formulare/{antragsnummer}': {
        get: {
            req: {
                antragsnummer: string;
                onlyStammdaten?: boolean;
                unternehmenId: number;
            };
            res: {
                /**
                 * FormContent was returned
                 */
                200: FormContentDto;
            };
        };
    };
    '/ext/process/nscale/v1/antraege/platzhalter': {
        get: {
            req: {
                nscaleObjectIds: Array<string>;
            };
            res: {
                /**
                 * List of nscale objectIds of Platzhalterantraege and whether they where transferred was returned
                 */
                200: Array<PlatzhalterantragStatusDto>;
            };
        };
    };
    '/batch/ffa/v1/job/stammdaten': {
        get: {
            res: {
                /**
                 * Stammdaten job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/nscale': {
        get: {
            res: {
                /**
                 * Nscale job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/monitor': {
        get: {
            res: {
                /**
                 * Monitor job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/mailer': {
        get: {
            res: {
                /**
                 * Mailer job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/fileTransfer': {
        get: {
            res: {
                /**
                 * FileTransfer job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/cleanUp': {
        get: {
            res: {
                /**
                 * CleanUp job was started
                 */
                200: any;
            };
        };
    };
    '/batch/ffa/v1/job/antragS3': {
        get: {
            res: {
                /**
                 * AntragS3 job was started
                 */
                200: any;
            };
        };
    };
};
